import { UserHttpService } from "core/services/user";
import { HttpService } from "core/services/http";
import { useQuery } from "react-query";

/**
 * A custom hook for fetching the user profile.
 * @returns {{
 *   data: any,
 *   isLoading: boolean,
 *   isError: boolean,
 *   refetch: Function,
 * }}
 */
function useProfile(options = {}) {
  const { data, isLoading, isError, refetch } = useQuery(
    "profile",
    () => UserHttpService.loadProfile(),
    {
      enabled: options.enabled !== false, // Default to true if not specified
      onSuccess: (data) => {
        // Save role to localStorage for quick access
        if (data?.role) {
          const user = HttpService.getUser();
          if (user) {
            HttpService.setUser({
              ...user,
              role: data.role
            });
          } else {
            // If no user object exists, create a minimal one with role
            HttpService.setUser({
              role: data.role
            });
          }
        }
      },
      onError: (error) => {
        console.error("Error loading profile:", error);
      },
    }
  );

  return { data, isLoading, isError, refetch };
}

export default useProfile;
